// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__dLVdt","anima":"Alert_anima__43bLR"};